/**
 * Initialize Swiper sliders for content image sliders
 */

/* global Swiper, jQuery */

jQuery(document).ready(function ($) {
  if (!$('.content-image-slider').length) {
    return;
  }

  const sliderPosts = $('.content-image-slider');

  sliderPosts.each(function (index) {
    const $post = $(this);
    const $postContainer = $post.closest('.content-image-slider-outer-container');
    const sliderId = `content-image-slider-${index}`;
    const sliderContainerId = `content-image-slider-container-${index}`;

    if (!$postContainer.length) {
      return;
    }

    $post.attr('id', sliderId);
    $postContainer.attr('id', sliderContainerId);
    $post.addClass('swiper');

    // Function to update slide info
    function updateSlideInfo(swiperInstance) {
      const $activeSlide = $(swiperInstance.slides[swiperInstance.activeIndex]);
      const slideId = $activeSlide.data('slide-id');

      const $contentBlock = $postContainer.find(`.slide-data[data-slide-id="${slideId}"]`);
      const $slideInfo = $postContainer.find('.slider-info');

      if ($contentBlock.length && $slideInfo.length) {
        // Fade out effect
        $slideInfo.fadeOut(200, function () {
          $slideInfo.html($contentBlock.html()).fadeIn(200);
        });
      }

      updateSteps(slideId);
    }

    // Function to sync the step circles with the active slide
    function updateSteps(slideId) {
      const $steps = $postContainer.prev('.slider-steps');

      if (!$steps.length || typeof slideId === 'undefined') {
        return;
      }

      const activeIndex = parseInt(String(slideId).replace('slide-', ''), 10);

      if (isNaN(activeIndex)) {
        return;
      }

      $steps.find('.step-circle').each(function () {
        const stepIndex = parseInt($(this).data('step-index'), 10);
        $(this).toggleClass('is-active', stepIndex <= activeIndex);
      });
    }

    // Initialize Swiper with navigation
    new Swiper(`#${sliderId}`, {
      slidesPerView: 1.15,
      spaceBetween: 10,
      // Mobile-only: centers the active slide
      centeredSlides: true,
      loop: true,
      // Swiper navigation
      navigation: {
        nextEl: `#${sliderContainerId} .slider-next`,
        prevEl: `#${sliderContainerId} .slider-prev`,
      },
      breakpoints: {
        640: {
          spaceBetween: 20,
        },
        768: {
          centeredSlides: false,
        },
        1024: {
          spaceBetween: 30,
          centeredSlides: false,
        },
      },
      on: {
        slideChange: function () {
          updateSlideInfo(this);
        },
        init: function () {
          updateSlideInfo(this);
        },
      },
    });
  });
});
